import React from "react";
import Clock from "../../../../Clock";
import "../../../../Styles/TopNav.css";
import DropdownMenu from "./Buttons/DropdownMenu";

import { AlarmBrake } from "./Buttons/AlarmButton";
import RaiseHand from "./Buttons/RaiseHand";
import { ToiletBrake } from "./Buttons/ToiletBrake";

const TopNav = ({
  shouldAddAskToilet = false,
  shouldAddRaiseHand = false,
  maxQuestionIndex = 0,
  firstQuestionIndex = 0,
  jumpToQuestions = null,
  title = "מבחן מיון"
} = {}) => {
  return (
    <>
      <nav className="nav">
        <ul> {Clock()} :שעה</ul>
        <ul style={{ flex: 1, display: "flex", justifyContent: "center" }}>
          <li className="site-title">{title}</li>
        </ul>
        <ul style={{ marginRight: "50px" }}>{ }</ul>
        <ul>
          {/* Dropdown menu for jumping to questions: */}
          {Number.isFinite(maxQuestionIndex) && maxQuestionIndex > 0 && (
            <DropdownMenu
              maxQuestionIndex={maxQuestionIndex}
              firstQuestionIndex={firstQuestionIndex}
              jumpToQuestions={jumpToQuestions}
            />
          )}
          {shouldAddAskToilet && <ToiletBrake />}
          {shouldAddRaiseHand && <RaiseHand />}
          {(shouldAddAskToilet || shouldAddRaiseHand) && <AlarmBrake />}
        </ul>
      </nav>
    </>
  );
};

export default TopNav;
